package com.damda.design_system.ui.views.compose_migrations.layouts

import androidx.compose.runtime.Composable
import com.damda.design_system.ui.views.lists.FoodItem
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.right
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun AppBar(title: String, onBackArrowClick: () -> Unit) {
    Div(
        attrs = {
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.SpaceBetween)
                padding(16.px)
                backgroundColor(Color.white)
            }
        }
    ) {
        Button(
            attrs = {
                style {
                    backgroundColor(Color.transparent)
                    border(0.px)
                }
                onClick {
                    onBackArrowClick()
                }
            }
        ) {
            Img(src = "ic_backarrow.png", attrs = { style { width(8.px); height(14.px) } })
        }
        Span(
            attrs = {
                style {
                    fontSize(20.px)
                    fontWeight(500) // semibold
                    color(Color("#333333"))
                    textAlign("center")
                    flexGrow(1)
                }
            }
        ) {
            Text(title)
        }
        Button(
            attrs = {
                style {
                    backgroundColor(Color.transparent)
                    border(0.px)
                }
            }
        ) {
            Img(src = "ic_more.png", attrs = { style { width(24.px); height(6.px) } })
        }
    }
}